import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/components/header/HeaderRight.tsx");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/header/Fetcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/header/LocalChainTimeNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/header/nav.tsx");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/app/images/icon_arrow_right_up.svg");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/app/images/icon_arrow_right.svg");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/app/images/icon_dan.svg");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/app/images/icon_metamask.svg");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/www/.buckydao-build-1607de7/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../public/Poppins.ttf\",\"display\":\"swap\"}],\"variableName\":\"font\"}");
